import { useSyncExternalStore } from "react";

// The player reports its position every ~500ms. Keeping that sample out of the
// app context means a progress tick only re-renders the progress bar, not the
// whole app. The bar extrapolates between samples from `receivedAt`.

export interface ProgressSample {
  progress: number; // seconds
  isPlaying: boolean;
  receivedAt: number; // performance.now() when the sample arrived
}

let sample: ProgressSample = {
  progress: 0,
  isPlaying: false,
  receivedAt: performance.now(),
};
const listeners = new Set<() => void>();

export const setProgressSample = (progress: number, isPlaying: boolean) => {
  sample = { progress, isPlaying, receivedAt: performance.now() };
  listeners.forEach((listener) => listener());
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const useProgressSample = () =>
  useSyncExternalStore(subscribe, () => sample);
